<template>
    <transition name="modal">
        <div class="modal-mask" v-if="store.showFirewallPopup" v-show="store.showFirewallPopup">
            <div class="modal-container" style="width: 50%;">
                <div class="modal-header">
                    <h3><i style="position: absolute;margin-top: -4px;" class="material-icons">error</i> <span style="margin-left:27px">Error</span></h3>
                    <v-btn class="close isMobile" flat @click="notify()"><i class="material-icons">clear</i></v-btn>
                </div>
                <div class="model-body-container" style="padding: 20PX;">
                    <strong style="font-size: 16px;">Oops, something went wrong. The Portal team has been notified and will let you know as soon as it's resolved. We apologize for the inconvenience.</strong>
                    <!-- <div class="paper-doc-latter-text">
                        <p><strong>{{ store.firewall_id}}</strong></p>
                        <p><strong>{{ store.firewall_ip}}</strong></p>
                    </div> -->
                </div>
                <!-- <div class="modal-footer text-right text-center">
                    <a class="modal-default-button btn btn-pop-line" href="javascript:void(0)" @click="notify()">Notify The Team</a>
                    <a class="modal-default-button btn btn-pop-filled margin-left-5" href="javascript:void(0)" @click="downloadReport()">Download Report</a>
                </div> -->
            </div>
        </div>
    </transition>
</template>

<script>
import { ref } from 'vue';
import { store } from '@/store/store.js';

export default {
    name: 'FirewallPopup',
    props: ['show', 'fee_crm_id'],
    setup(props) {
        var show_pop = ref(props.show);
        var feeid = ref(props.fee_crm_id);
       
        const notify = function () {
            store.showFirewallPopup = false;
            document.body.style.overflow = "visible";
        }

        const downloadReport = function () {
          
        }

        return {
            store,
            show_pop,
            feeid,
            notify,
            downloadReport
        }
    }
}
</script>
